/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';
import { dispatchClearNDCActivityReduxData } from '../../AccRecNDCActivity/store/actions';

export const singleAccRecNDCDetail = (data) => ({
  type: actiontypes.SINGLE_ACC_REC_NDC__DETAIL_TABLE,
  getSingleAccRecNDCDetailList: data,
});

export const ndcDetailSingle = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    try {
      let accRecNDCDetailheaderData = {
        [data.pgmCd]: data,
      };
      dispatch({
        type: actiontypes.SINGLE_NDC_DETAIL,
        singleNdcDetailList: accRecNDCDetailheaderData,
      });
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

export const ndcDetailFirstLoadAction = (val) => {
  return { type: actiontypes.AR_NDC_DETAIL_FIRST_LOAD, payload: val };
};
export const dispatchNDCBalanceDue = (val) => ({
  type: actiontypes.NDC_BALANCE_DUE,
  getBalnceDue: val,
});
export const dispatchNDCOveridden = (val) => ({
  type: actiontypes.NDC_OVERRIDDEN,
  getOverridden: val,
});
export const dispatchNDCPaidInFull = (val) => ({
  type: actiontypes.NDC_PAID_FULL,
  getPaidInFull: val,
});
export const dispatchModificationFromAr = (val) => ({
  type: actiontypes.MODIFICATION_FROM_AR,
  modificationFromAr: val,
});

export const setUnitsToClaimOnload = (data) => {
  return axios
    .post(serviceEndPoint.GET_AR_UNIT_CLAIM_LOAD, data)
    .then((response) => {
      return response;
    })
    .catch(() => {
      return false;
    });
};

export const dispatchClearNDCDetailReduxData = (val) => {
  return { type: actiontypes.ACCOUNT_REC_NDC_DETAIL_CLEAR_REDUX, payload: val };
};

export const clearAccountRecNDCDetailPage =
  (history) => (dispatch, getState) => {
    // const reduxObj = getState()?.sharedState?.AccRecNDCActivityReducer;
    // const reduxObj1 = getState()?.sharedState?.AccRecNDCDetailReducer;
    // const updateTabs =
    //   JSON.parse(localStorage.getItem('tabItemsData')) === null
    //     ? []
    //     : JSON.parse(localStorage.getItem('tabItemsData'));
    // let changePass = false;
    // let newObj1 = {};
    // let nObj1 = {};
    // if (!_.isEmpty(updateTabs)) {
    //   const newObj = _.cloneDeep(reduxObj);
    //   const nObj = _.cloneDeep(reduxObj1);
    //   if (
    //     updateTabs.filter((x) => x.navTo === '/AccRecNDCActivity').length === 0
    //   ) {
    //     newObj1 = {
    //       activity_type_principal: false,
    //       activity_type_interest: false,
    //     };
    //     nObj1 = { modificationFromAr: [] };
    //     changePass = true;
    //   } else {
    //     nObj1.modificationFromAr = nObj.modificationFromAr || [];
    //     nObj1.ndcActFirstLoad = nObj.ndcActFirstLoad || null;
    //     newObj1 = newObj;
    //   }
    // } else {
    //   changePass = true;
    //   nObj1 = { modificationFromAr: [] };
    //   newObj1 = {
    //     activity_type_principal: false,
    //     activity_type_interest: false,
    //   };
    // }
    // if (changePass) {
    //   dispatch(dispatchClearNDCActivityReduxData(newObj1));
    // }
    const reduxObj1 = getState()?.sharedState?.AccRecNDCDetailReducer;
    dispatch(dispatchClearNDCDetailReduxData(reduxObj1));
  };

export const getRefreshTableData = (val) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_AR_NDC_SGL_RPC}`, val)
    .then((response) => response.data)
    .catch(() => []);
};
